import React from "react";

import "./style.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="credit-text left">
        © 2025 Léanne Lopez. Tous droits réservés.
      </p>
      <div className="right-texts">
        <p className="credit-text">/archives</p>
        <p className="credit-text">maj 06/2025</p>
      </div>
    </footer>
  );
};

export default Footer;
